export const useSxStyles = () => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    spinner: {
      margin: 'auto',
    },
    errorMessage: {
      margin: 'auto',
      textAlign: 'center',
    },
    fullHeight: {
      height: '100%',
    },
  };
};
